export default __webpack_public_path__ + "static/media/ac-logo-color.b28cc0c9.svg";